var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#707175"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.143 12.181c0-5.575 4.495-10.08 10.06-10.08 5.566 0 10.061 4.505 10.061 10.08 0 5.576-4.495 10.08-10.06 10.08-2.057 0-3.958-.596-5.676-1.752L2.125 22.38l1.85-4.369-.004-.03-.011-.014a10.306 10.306 0 01-1.814-5.533l-.003-.254zm19.162 0c0-5.046-4.067-9.12-9.101-9.12-5.035 0-9.1 4.074-9.1 9.12 0 1.84.58 3.687 1.648 5.243l-.01-.014.013.014a.805.805 0 01.146.31l.018.087c.015.096.019.169.019.283v.098l-1.003 2.366 2.096-.89.014-.017a.62.62 0 01.385-.191l.066-.007c.134 0 .192.003.292.037.116.039.214.11.283.203l.013.021.106.071c1.455.95 3.041 1.456 4.756 1.502l.258.004c5.034 0 9.1-4.074 9.1-9.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.22 15.358c-.204 0-.407-.204-.407-.408v-2.345c0-.204.203-.407.407-.407 1.22 0 2.238-1.02 2.238-2.243 0-1.223-1.017-2.243-2.238-2.243s-2.238 1.02-2.238 2.243c0 .204-.204.408-.407.408-.204 0-.407-.204-.407-.408 0-1.733 1.424-3.16 3.154-3.16s3.153 1.427 3.153 3.16c0 1.529-1.119 2.854-2.645 3.058v1.937c-.203.204-.407.408-.61.408z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3,
    cy: 17.1,
    r: 0.9
  }))));
}

export default SvgQuestionDisabled;